import PropTypes from 'prop-types'
import { MenuDrawer } from './MenuDrawer'
import { useIsMobileMenu } from '../hooks/useMenuViewport'

const EMPTY_FOOTER_ITEMS = []

const resolveMenuMode = (mode, viewportIsMobile) => {
  if (mode !== 'auto') return mode
  return viewportIsMobile ? 'mobile' : 'desktop'
}

/**
 * Entrada principal para consumir el menú en modo automático o forzado.
 * @param {import('../Menu.types').MenuResponsiveProps} props
 */
export function MenuResponsive({
  items,
  onSelect,
  mobileOpen = false,
  mobileInitialFooterItemId,
  onMobileOpenChange,
  footerItems = EMPTY_FOOTER_ITEMS,
  mode = 'auto',
  className,
  dataTestId,
  DesktopComponent,
}) {
  const viewportIsMobile = useIsMobileMenu()
  const resolvedMode = resolveMenuMode(mode, viewportIsMobile)

  if (resolvedMode === 'mobile') {
    if (!mobileOpen) return null

    return (
      <MenuDrawer
        items={items}
        isOpen
        initialFooterItemId={mobileInitialFooterItemId}
        onOpenChange={onMobileOpenChange}
        onSelect={onSelect}
        footerItems={footerItems}
        className={className}
        dataTestId={dataTestId}
      />
    )
  }

  return <DesktopComponent items={items} onSelect={onSelect} className={className} dataTestId={dataTestId} />
}

MenuResponsive.propTypes = {
  items: PropTypes.array.isRequired,
  onSelect: PropTypes.func,
  mobileOpen: PropTypes.bool,
  mobileInitialFooterItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onMobileOpenChange: PropTypes.func,
  footerItems: PropTypes.array,
  mode: PropTypes.oneOf(['auto', 'desktop', 'mobile']),
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  DesktopComponent: PropTypes.elementType.isRequired,
}
